<template>
  <div id="privacy_policy">
    <TerrorZoneNavBar />
    <div class="privacy-content">
      <h1> Privacy Policy </h1>
      <p>We value your privacy and are committed to protecting your personal information. Please read the following privacy policy carefully to understand how we collect, use, and protect your data.</p>

      <h2>1. Data Collection</h2>

      <h3>1.1 IP Address</h3>
      <p>We collect users' IP addresses to monitor service abuse and ensure the security of our systems. The collection of IP addresses also helps us analyze trends, manage the website, track user behavior patterns, and optimize the user experience.</p>

      <h3>1.2 Operational Data</h3>
      <p>We collect users' operational data to monitor service abuse and identify and fix potential system vulnerabilities. This data is stored in server log files and is used to improve our services, enhance system stability, and optimize the user experience.</p>
      <p>If you use our notification system, we will collect your publicly available 3rd party application information, such as your DISCORD ID and DISCORD language settings. This information is used to improve user interactions, enhance service experience, and ensure the effectiveness of notifications.</p>

      <h3>1.3 Cookies</h3>
      <p>Similar to most online services, we and our partners (such as Google Analytics) use cookies and similar technologies to provide and optimize personalized services, analyze usage, customize advertisements, and prevent fraud. Cookies and similar technologies allow us and our partners to store user preferences and track their activities within our services.</p>
      <p>This data may include IP addresses, device identifiers, browser attributes, operating system details, language settings, referring URLs, time spent on the site, and visited pages. You can disable cookies in your browser settings, but please note that this may affect the functionality of certain parts of our services.</p>
      
      <h2>2. Data Security</h2>
      <p>We implement reasonable technical and managerial measures to protect your personal data from unauthorized access, use, or disclosure. However, despite our best efforts, internet communications are not 100% secure, and we cannot guarantee that your data will not be accessed by unauthorized parties.</p>

      <h2>3. Your Rights</h2>
      <p>Under applicable data protection laws, you may have the following rights:</p>
      <ul>
          <li>Access, update, or delete your personal data</li>
          <li>Disable or manage the use of cookies</li>
      </ul>
      <p>If you wish to exercise your rights or have any questions about this privacy policy, please contact us.</p>

      <h2>4. Updates to This Privacy Policy</h2>
      <p>We may update this privacy policy from time to time to reflect changes in our data practices or legal requirements. The latest version of this privacy policy will always be available on our website.</p>

      <h2>5. Contact Us</h2>
      <p>If you have any questions or concerns about this privacy policy, please contact us at support@d2tz.info</p>
    </div>
    <TerrorZoneFooter class="mt-4"/>
  </div>
</template>

<script>
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'

export default {
  name: 'PrivacyPolicy',

  components: {
    TerrorZoneNavBar,
    TerrorZoneFooter,
  },
}
</script>

<style scoped>
.privacy-content {
  color: #fff;
  justify-content: space-around;
  max-width: 900px;
  margin: 40px auto;
  width: 70%;
}
@media (max-width: 600px) {
  .privacy-content {
    width: 90%;
  }
}
</style>
